// Comprehensive global location data for ad targeting
export interface Location {
  country: string;
  countryCode: string;
  states?: State[];
}

export interface State {
  name: string;
  cities: string[];
}

// User location interface (from IP detection)
export interface UserLocation {
  country: string;
  countryCode: string;
  state?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
}

export const LOCATIONS: Location[] = [
  // AFRICA
  {
    country: 'Nigeria',
    countryCode: 'NG',
    states: [
      { name: 'Lagos', cities: ['Ikeja', 'Victoria Island', 'Lekki', 'Surulere', 'Yaba', 'Ikorodu', 'Epe', 'Badagry', 'Apapa', 'Ojo', 'Alimosho', 'Agege', 'Mushin', 'Shomolu', 'Kosofe', 'Ifako-Ijaiye'] },
      { name: 'Abuja FCT', cities: ['Central Business District', 'Garki', 'Wuse', 'Maitama', 'Asokoro', 'Gwarinpa', 'Kubwa', 'Dutse', 'Bwari', 'Gwagwalada', 'Kuje', 'Abaji'] },
      { name: 'Kano', cities: ['Kano Municipal', 'Nassarawa', 'Fagge', 'Dala', 'Gwale', 'Tarauni', 'Kumbotso', 'Ungogo'] },
      { name: 'Rivers', cities: ['Port Harcourt', 'Obio-Akpor', 'Bonny', 'Eleme', 'Okrika', 'Ogu', 'Oyigbo', 'Ikwerre'] },
      { name: 'Oyo', cities: ['Ibadan', 'Ogbomoso', 'Oyo', 'Iseyin', 'Saki', 'Igbo-Ora', 'Eruwa'] },
      { name: 'Kaduna', cities: ['Kaduna', 'Zaria', 'Kafanchan', 'Kagoro', 'Kachia', 'Birnin Gwari'] },
      { name: 'Ogun', cities: ['Abeokuta', 'Ijebu Ode', 'Sagamu', 'Ilaro', 'Ota', 'Ago-Iwoye', 'Ijebu-Igbo'] },
      { name: 'Edo', cities: ['Benin City', 'Auchi', 'Ekpoma', 'Uromi', 'Ubiaja', 'Irrua'] },
      { name: 'Delta', cities: ['Warri', 'Asaba', 'Sapele', 'Ughelli', 'Agbor', 'Ozoro', 'Oleh'] },
      { name: 'Enugu', cities: ['Enugu', 'Nsukka', 'Agbani', 'Udi', 'Awgu', 'Ezeagu', 'Oji River'] },
      { name: 'Anambra', cities: ['Awka', 'Onitsha', 'Nnewi', 'Ekwulobia', 'Ihiala', 'Aguata'] },
      { name: 'Abia', cities: ['Umuahia', 'Aba', 'Arochukwu', 'Ohafia', 'Bende'] },
      { name: 'Imo', cities: ['Owerri', 'Orlu', 'Okigwe', 'Mbaise', 'Oguta'] },
      { name: 'Plateau', cities: ['Jos', 'Bukuru', 'Pankshin', 'Shendam', 'Langtang'] },
      { name: 'Bauchi', cities: ['Bauchi', 'Azare', 'Misau', 'Jama\'are', 'Katagum'] },
      { name: 'Borno', cities: ['Maiduguri', 'Biu', 'Bama', 'Dikwa', 'Monguno'] },
      { name: 'Akwa Ibom', cities: ['Uyo', 'Ikot Ekpene', 'Eket', 'Oron', 'Abak'] },
      { name: 'Cross River', cities: ['Calabar', 'Ugep', 'Ikom', 'Ogoja', 'Obudu'] },
      { name: 'Kwara', cities: ['Ilorin', 'Offa', 'Jebba', 'Omu-Aran', 'Lafiagi'] },
      { name: 'Osun', cities: ['Osogbo', 'Ile-Ife', 'Ilesha', 'Ede', 'Ikirun', 'Iwo'] },
      { name: 'Ondo', cities: ['Akure', 'Ondo', 'Owo', 'Ikare', 'Ore'] },
      { name: 'Ekiti', cities: ['Ado-Ekiti', 'Ikere', 'Aramoko', 'Omuo', 'Efon Alaaye'] },
      { name: 'Niger', cities: ['Minna', 'Bida', 'Kontagora', 'Suleja', 'Lapai'] },
      { name: 'Kogi', cities: ['Lokoja', 'Okene', 'Kabba', 'Idah', 'Ankpa'] },
      { name: 'Benue', cities: ['Makurdi', 'Gboko', 'Otukpo', 'Katsina-Ala', 'Vandeikya'] },
      { name: 'Taraba', cities: ['Jalingo', 'Wukari', 'Ibi', 'Bali', 'Gembu'] },
      { name: 'Adamawa', cities: ['Yola', 'Jimeta', 'Mubi', 'Numan', 'Ganye'] },
      { name: 'Gombe', cities: ['Gombe', 'Kumo', 'Billiri', 'Deba', 'Kaltungo'] },
      { name: 'Yobe', cities: ['Damaturu', 'Potiskum', 'Gashua', 'Nguru', 'Geidam'] },
      { name: 'Jigawa', cities: ['Dutse', 'Hadejia', 'Gumel', 'Kazaure', 'Ringim'] },
      { name: 'Katsina', cities: ['Katsina', 'Daura', 'Funtua', 'Malumfashi', 'Kankia'] },
      { name: 'Sokoto', cities: ['Sokoto', 'Tambuwal', 'Gwadabawa', 'Wurno', 'Goronyo'] },
      { name: 'Zamfara', cities: ['Gusau', 'Kaura Namoda', 'Talata Mafara', 'Anka', 'Bungudu'] },
      { name: 'Kebbi', cities: ['Birnin Kebbi', 'Argungu', 'Zuru', 'Yauri', 'Jega'] },
      { name: 'Bayelsa', cities: ['Yenagoa', 'Brass', 'Nembe', 'Oporoma', 'Twon-Brass'] },
      { name: 'Ebonyi', cities: ['Abakaliki', 'Afikpo', 'Onueke', 'Ezza', 'Uburu'] },
      { name: 'Nasarawa', cities: ['Lafia', 'Keffi', 'Akwanga', 'Doma', 'Karu'] }
    ]
  },
  {
    country: 'Ghana',
    countryCode: 'GH',
    states: [
      { name: 'Greater Accra', cities: ['Accra', 'Tema', 'Madina', 'Adenta', 'Teshie', 'Nungua', 'Ga Mashie', 'Dansoman', 'Kaneshie', 'Spintex'] },
      { name: 'Ashanti', cities: ['Kumasi', 'Obuasi', 'Ejisu', 'Mampong', 'Konongo', 'Bekwai', 'Juaben'] },
      { name: 'Western', cities: ['Sekondi-Takoradi', 'Tarkwa', 'Axim', 'Prestea', 'Shama'] },
      { name: 'Eastern', cities: ['Koforidua', 'Nkawkaw', 'Mpraeso', 'Akropong', 'Somanya'] },
      { name: 'Central', cities: ['Cape Coast', 'Winneba', 'Kasoa', 'Swedru', 'Saltpond'] },
      { name: 'Northern', cities: ['Tamale', 'Yendi', 'Savelugu', 'Tolon', 'Gushegu'] },
      { name: 'Volta', cities: ['Ho', 'Hohoe', 'Keta', 'Aflao', 'Kpando'] },
      { name: 'Brong-Ahafo', cities: ['Sunyani', 'Techiman', 'Berekum', 'Dormaa Ahenkro', 'Wenchi'] },
      { name: 'Upper East', cities: ['Bolgatanga', 'Navrongo', 'Bawku', 'Paga', 'Zebilla'] },
      { name: 'Upper West', cities: ['Wa', 'Tumu', 'Lawra', 'Jirapa', 'Nadowli'] }
    ]
  },
  {
    country: 'Kenya',
    countryCode: 'KE',
    states: [
      { name: 'Nairobi', cities: ['Nairobi', 'Westlands', 'Kasarani', 'Embakasi', 'Dagoretti', 'Kibera', 'Langata', 'Makadara'] },
      { name: 'Mombasa', cities: ['Mombasa', 'Likoni', 'Changamwe', 'Jomvu', 'Kisauni', 'Nyali'] },
      { name: 'Kisumu', cities: ['Kisumu', 'Ahero', 'Maseno', 'Muhoroni'] },
      { name: 'Nakuru', cities: ['Nakuru', 'Naivasha', 'Gilgil', 'Molo', 'Njoro'] },
      { name: 'Kiambu', cities: ['Thika', 'Kiambu', 'Kikuyu', 'Ruiru', 'Limuru', 'Karuri'] },
      { name: 'Eldoret', cities: ['Eldoret', 'Turbo', 'Kapsabet', 'Iten'] },
      { name: 'Machakos', cities: ['Machakos', 'Athi River', 'Kangundo', 'Matuu'] }
    ]
  },
  {
    country: 'South Africa',
    countryCode: 'ZA',
    states: [
      { name: 'Gauteng', cities: ['Johannesburg', 'Pretoria', 'Soweto', 'Sandton', 'Midrand', 'Randburg', 'Centurion', 'Benoni', 'Boksburg'] },
      { name: 'Western Cape', cities: ['Cape Town', 'Stellenbosch', 'Paarl', 'George', 'Worcester', 'Mossel Bay'] },
      { name: 'KwaZulu-Natal', cities: ['Durban', 'Pietermaritzburg', 'Richards Bay', 'Newcastle', 'Ladysmith'] },
      { name: 'Eastern Cape', cities: ['Port Elizabeth', 'East London', 'Mthatha', 'Grahamstown', 'Queenstown'] },
      { name: 'Limpopo', cities: ['Polokwane', 'Tzaneen', 'Thohoyandou', 'Lephalale'] },
      { name: 'Mpumalanga', cities: ['Nelspruit', 'Witbank', 'Secunda', 'Middelburg'] }
    ]
  },
  {
    country: 'Egypt',
    countryCode: 'EG',
    states: [
      { name: 'Cairo', cities: ['Cairo', 'Giza', 'Heliopolis', 'Nasr City', 'Maadi', 'Helwan', 'Shubra El-Kheima'] },
      { name: 'Alexandria', cities: ['Alexandria', 'Borg El Arab', 'Montaza', 'Sidi Gaber'] },
      { name: 'Giza', cities: ['Giza', '6th of October City', 'Sheikh Zayed'] },
      { name: 'Qalyubia', cities: ['Banha', 'Qalyub', 'Shubra El-Kheima'] }
    ]
  },
  {
    country: 'Ethiopia',
    countryCode: 'ET',
    states: [
      { name: 'Addis Ababa', cities: ['Addis Ababa', 'Bole', 'Kirkos', 'Arada'] },
      { name: 'Oromia', cities: ['Adama', 'Jimma', 'Bishoftu', 'Shashamane'] },
      { name: 'Amhara', cities: ['Bahir Dar', 'Gondar', 'Dessie'] }
    ]
  },
  {
    country: 'Tanzania',
    countryCode: 'TZ',
    states: [
      { name: 'Dar es Salaam', cities: ['Dar es Salaam', 'Kinondoni', 'Temeke', 'Ilala'] },
      { name: 'Mwanza', cities: ['Mwanza', 'Ilemela', 'Nyamagana'] },
      { name: 'Arusha', cities: ['Arusha', 'Moshi', 'Karatu'] }
    ]
  },
  {
    country: 'Uganda',
    countryCode: 'UG',
    states: [
      { name: 'Central', cities: ['Kampala', 'Entebbe', 'Mukono', 'Wakiso'] },
      { name: 'Western', cities: ['Mbarara', 'Fort Portal', 'Kasese'] },
      { name: 'Eastern', cities: ['Jinja', 'Mbale', 'Tororo'] }
    ]
  },

  // NORTH AMERICA
  {
    country: 'United States',
    countryCode: 'US',
    states: [
      { name: 'California', cities: ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose', 'Sacramento', 'Oakland', 'Fresno', 'Long Beach', 'Anaheim', 'Bakersfield', 'Riverside', 'Santa Ana', 'Irvine', 'Berkeley', 'Pasadena'] },
      { name: 'Texas', cities: ['Houston', 'Dallas', 'Austin', 'San Antonio', 'Fort Worth', 'El Paso', 'Arlington', 'Corpus Christi', 'Plano', 'Laredo'] },
      { name: 'New York', cities: ['New York City', 'Buffalo', 'Rochester', 'Syracuse', 'Albany', 'Yonkers', 'New Rochelle'] },
      { name: 'Florida', cities: ['Miami', 'Orlando', 'Tampa', 'Jacksonville', 'Fort Lauderdale', 'St. Petersburg', 'Tallahassee', 'Port St. Lucie', 'Cape Coral'] },
      { name: 'Illinois', cities: ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield', 'Peoria'] },
      { name: 'Pennsylvania', cities: ['Philadelphia', 'Pittsburgh', 'Allentown', 'Erie', 'Reading', 'Scranton'] },
      { name: 'Ohio', cities: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton'] },
      { name: 'Georgia', cities: ['Atlanta', 'Augusta', 'Columbus', 'Savannah', 'Athens', 'Macon'] },
      { name: 'North Carolina', cities: ['Charlotte', 'Raleigh', 'Greensboro', 'Durham', 'Winston-Salem', 'Fayetteville'] },
      { name: 'Michigan', cities: ['Detroit', 'Grand Rapids', 'Warren', 'Sterling Heights', 'Ann Arbor', 'Lansing'] },
      { name: 'New Jersey', cities: ['Newark', 'Jersey City', 'Paterson', 'Elizabeth', 'Trenton'] },
      { name: 'Virginia', cities: ['Virginia Beach', 'Norfolk', 'Richmond', 'Arlington', 'Chesapeake', 'Newport News'] },
      { name: 'Washington', cities: ['Seattle', 'Spokane', 'Tacoma', 'Vancouver', 'Bellevue', 'Everett'] },
      { name: 'Arizona', cities: ['Phoenix', 'Tucson', 'Mesa', 'Chandler', 'Scottsdale', 'Glendale'] },
      { name: 'Massachusetts', cities: ['Boston', 'Worcester', 'Springfield', 'Cambridge', 'Lowell'] },
      { name: 'Tennessee', cities: ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga', 'Clarksville'] },
      { name: 'Indiana', cities: ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel'] },
      { name: 'Missouri', cities: ['Kansas City', 'St. Louis', 'Springfield', 'Columbia', 'Independence'] },
      { name: 'Maryland', cities: ['Baltimore', 'Columbia', 'Germantown', 'Silver Spring', 'Waldorf'] },
      { name: 'Wisconsin', cities: ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha', 'Racine'] },
      { name: 'Colorado', cities: ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins', 'Lakewood'] },
      { name: 'Minnesota', cities: ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth', 'Bloomington'] },
      { name: 'South Carolina', cities: ['Columbia', 'Charleston', 'North Charleston', 'Greenville', 'Rock Hill'] },
      { name: 'Alabama', cities: ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville', 'Tuscaloosa'] },
      { name: 'Louisiana', cities: ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette', 'Lake Charles'] },
      { name: 'Kentucky', cities: ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro', 'Covington'] },
      { name: 'Oregon', cities: ['Portland', 'Salem', 'Eugene', 'Gresham', 'Hillsboro'] },
      { name: 'Oklahoma', cities: ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow', 'Lawton'] },
      { name: 'Connecticut', cities: ['Bridgeport', 'New Haven', 'Stamford', 'Hartford', 'Waterbury'] },
      { name: 'Utah', cities: ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan', 'Orem'] },
      { name: 'Nevada', cities: ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas', 'Sparks'] },
      { name: 'Arkansas', cities: ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale', 'Jonesboro'] },
      { name: 'Mississippi', cities: ['Jackson', 'Gulfport', 'Southaven', 'Hattiesburg', 'Biloxi'] },
      { name: 'Kansas', cities: ['Wichita', 'Overland Park', 'Kansas City', 'Topeka', 'Olathe'] },
      { name: 'New Mexico', cities: ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe', 'Roswell'] },
      { name: 'Nebraska', cities: ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island'] },
      { name: 'West Virginia', cities: ['Charleston', 'Huntington', 'Morgantown', 'Parkersburg'] },
      { name: 'Idaho', cities: ['Boise', 'Meridian', 'Nampa', 'Idaho Falls', 'Pocatello'] },
      { name: 'Hawaii', cities: ['Honolulu', 'Pearl City', 'Hilo', 'Kailua', 'Waipahu'] },
      { name: 'New Hampshire', cities: ['Manchester', 'Nashua', 'Concord', 'Derry'] },
      { name: 'Maine', cities: ['Portland', 'Lewiston', 'Bangor', 'South Portland'] },
      { name: 'Montana', cities: ['Billings', 'Missoula', 'Great Falls', 'Bozeman'] },
      { name: 'Rhode Island', cities: ['Providence', 'Warwick', 'Cranston', 'Pawtucket'] },
      { name: 'Delaware', cities: ['Wilmington', 'Dover', 'Newark', 'Middletown'] },
      { name: 'South Dakota', cities: ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings'] },
      { name: 'North Dakota', cities: ['Fargo', 'Bismarck', 'Grand Forks', 'Minot'] },
      { name: 'Alaska', cities: ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka'] },
      { name: 'Vermont', cities: ['Burlington', 'Essex', 'South Burlington', 'Colchester'] },
      { name: 'Wyoming', cities: ['Cheyenne', 'Casper', 'Laramie', 'Gillette'] }
    ]
  },
  {
    country: 'Canada',
    countryCode: 'CA',
    states: [
      { name: 'Ontario', cities: ['Toronto', 'Ottawa', 'Mississauga', 'Hamilton', 'London', 'Kitchener', 'Windsor', 'Burlington', 'Oakville', 'Oshawa', 'Barrie', 'Guelph', 'Cambridge'] },
      { name: 'Quebec', cities: ['Montreal', 'Quebec City', 'Laval', 'Gatineau', 'Longueuil', 'Sherbrooke', 'Trois-Rivières'] },
      { name: 'British Columbia', cities: ['Vancouver', 'Victoria', 'Surrey', 'Burnaby', 'Richmond', 'Abbotsford', 'Kelowna', 'Coquitlam'] },
      { name: 'Alberta', cities: ['Calgary', 'Edmonton', 'Red Deer', 'Lethbridge', 'Fort McMurray'] },
      { name: 'Manitoba', cities: ['Winnipeg', 'Brandon', 'Steinbach', 'Thompson'] },
      { name: 'Saskatchewan', cities: ['Saskatoon', 'Regina', 'Prince Albert', 'Moose Jaw'] },
      { name: 'Nova Scotia', cities: ['Halifax', 'Dartmouth', 'Sydney', 'Truro'] },
      { name: 'New Brunswick', cities: ['Moncton', 'Saint John', 'Fredericton', 'Dieppe'] },
      { name: 'Newfoundland and Labrador', cities: ['St. John\'s', 'Mount Pearl', 'Corner Brook', 'Conception Bay South'] },
      { name: 'Prince Edward Island', cities: ['Charlottetown', 'Summerside', 'Stratford'] }
    ]
  },
  {
    country: 'Mexico',
    countryCode: 'MX',
    states: [
      { name: 'Mexico City', cities: ['Mexico City', 'Coyoacán', 'Iztapalapa', 'Benito Juárez'] },
      { name: 'Jalisco', cities: ['Guadalajara', 'Zapopan', 'Tlaquepaque', 'Tonalá'] },
      { name: 'Nuevo León', cities: ['Monterrey', 'Guadalupe', 'San Nicolás de los Garza', 'Apodaca'] },
      { name: 'Puebla', cities: ['Puebla', 'Tehuacán', 'Atlixco'] },
      { name: 'Guanajuato', cities: ['León', 'Irapuato', 'Celaya', 'Salamanca'] },
      { name: 'Chihuahua', cities: ['Chihuahua', 'Ciudad Juárez', 'Delicias', 'Cuauhtémoc'] },
      { name: 'Baja California', cities: ['Tijuana', 'Mexicali', 'Ensenada', 'Rosarito'] },
      { name: 'Veracruz', cities: ['Veracruz', 'Xalapa', 'Coatzacoalcos', 'Poza Rica'] }
    ]
  },

  // EUROPE
  {
    country: 'United Kingdom',
    countryCode: 'GB',
    states: [
      { name: 'England', cities: ['London', 'Manchester', 'Birmingham', 'Liverpool', 'Leeds', 'Bristol', 'Newcastle', 'Sheffield', 'Nottingham', 'Leicester', 'Southampton', 'Brighton', 'Portsmouth', 'Reading', 'Oxford', 'Cambridge'] },
      { name: 'Scotland', cities: ['Edinburgh', 'Glasgow', 'Aberdeen', 'Dundee', 'Inverness', 'Stirling'] },
      { name: 'Wales', cities: ['Cardiff', 'Swansea', 'Newport', 'Wrexham', 'Barry'] },
      { name: 'Northern Ireland', cities: ['Belfast', 'Derry', 'Lisburn', 'Newry'] }
    ]
  },
  {
    country: 'Germany',
    countryCode: 'DE',
    states: [
      { name: 'Bavaria', cities: ['Munich', 'Nuremberg', 'Augsburg', 'Regensburg', 'Ingolstadt'] },
      { name: 'North Rhine-Westphalia', cities: ['Cologne', 'Düsseldorf', 'Dortmund', 'Essen', 'Duisburg', 'Bochum', 'Bonn'] },
      { name: 'Baden-Württemberg', cities: ['Stuttgart', 'Mannheim', 'Karlsruhe', 'Freiburg', 'Heidelberg'] },
      { name: 'Berlin', cities: ['Berlin', 'Kreuzberg', 'Prenzlauer Berg', 'Charlottenburg'] },
      { name: 'Hamburg', cities: ['Hamburg', 'Altona', 'Eimsbüttel', 'Wandsbek'] },
      { name: 'Hesse', cities: ['Frankfurt', 'Wiesbaden', 'Kassel', 'Darmstadt'] },
      { name: 'Saxony', cities: ['Leipzig', 'Dresden', 'Chemnitz'] }
    ]
  },
  {
    country: 'France',
    countryCode: 'FR',
    states: [
      { name: 'Île-de-France', cities: ['Paris', 'Versailles', 'Boulogne-Billancourt', 'Saint-Denis', 'Nanterre'] },
      { name: 'Auvergne-Rhône-Alpes', cities: ['Lyon', 'Grenoble', 'Saint-Étienne', 'Annecy'] },
      { name: 'Provence-Alpes-Côte d\'Azur', cities: ['Marseille', 'Nice', 'Toulon', 'Cannes', 'Avignon'] },
      { name: 'Occitanie', cities: ['Toulouse', 'Montpellier', 'Nîmes', 'Perpignan'] },
      { name: 'Nouvelle-Aquitaine', cities: ['Bordeaux', 'Limoges', 'Poitiers', 'La Rochelle'] },
      { name: 'Hauts-de-France', cities: ['Lille', 'Amiens', 'Roubaix', 'Tourcoing'] },
      { name: 'Brittany', cities: ['Rennes', 'Brest', 'Quimper', 'Saint-Malo'] }
    ]
  },
  {
    country: 'Italy',
    countryCode: 'IT',
    states: [
      { name: 'Lazio', cities: ['Rome', 'Latina', 'Frosinone'] },
      { name: 'Lombardy', cities: ['Milan', 'Bergamo', 'Brescia', 'Monza', 'Como'] },
      { name: 'Campania', cities: ['Naples', 'Salerno', 'Caserta'] },
      { name: 'Sicily', cities: ['Palermo', 'Catania', 'Messina', 'Syracuse'] },
      { name: 'Veneto', cities: ['Venice', 'Verona', 'Padua', 'Vicenza'] },
      { name: 'Tuscany', cities: ['Florence', 'Pisa', 'Livorno', 'Siena'] },
      { name: 'Piedmont', cities: ['Turin', 'Alessandria', 'Asti', 'Novara'] }
    ]
  },
  {
    country: 'Spain',
    countryCode: 'ES',
    states: [
      { name: 'Madrid', cities: ['Madrid', 'Móstoles', 'Alcalá de Henares', 'Fuenlabrada'] },
      { name: 'Catalonia', cities: ['Barcelona', 'Hospitalet', 'Badalona', 'Terrassa', 'Sabadell'] },
      { name: 'Andalusia', cities: ['Seville', 'Málaga', 'Córdoba', 'Granada', 'Almería'] },
      { name: 'Valencia', cities: ['Valencia', 'Alicante', 'Elche', 'Castellón'] },
      { name: 'Basque Country', cities: ['Bilbao', 'Vitoria-Gasteiz', 'San Sebastián'] },
      { name: 'Galicia', cities: ['A Coruña', 'Vigo', 'Santiago de Compostela', 'Ourense'] }
    ]
  },
  {
    country: 'Netherlands',
    countryCode: 'NL',
    states: [
      { name: 'North Holland', cities: ['Amsterdam', 'Haarlem', 'Zaanstad', 'Alkmaar'] },
      { name: 'South Holland', cities: ['Rotterdam', 'The Hague', 'Leiden', 'Dordrecht'] },
      { name: 'North Brabant', cities: ['Eindhoven', 'Tilburg', 'Breda', 's-Hertogenbosch'] },
      { name: 'Utrecht', cities: ['Utrecht', 'Amersfoort', 'Nieuwegein'] }
    ]
  },
  {
    country: 'Poland',
    countryCode: 'PL',
    states: [
      { name: 'Masovian', cities: ['Warsaw', 'Radom', 'Płock'] },
      { name: 'Lesser Poland', cities: ['Kraków', 'Tarnów', 'Nowy Sącz'] },
      { name: 'Greater Poland', cities: ['Poznań', 'Kalisz', 'Konin'] },
      { name: 'Silesian', cities: ['Katowice', 'Częstochowa', 'Sosnowiec', 'Gliwice'] }
    ]
  },
  {
    country: 'Belgium',
    countryCode: 'BE',
    states: [
      { name: 'Brussels', cities: ['Brussels', 'Schaerbeek', 'Anderlecht', 'Ixelles'] },
      { name: 'Flanders', cities: ['Antwerp', 'Ghent', 'Bruges', 'Leuven'] },
      { name: 'Wallonia', cities: ['Charleroi', 'Liège', 'Namur', 'Mons'] }
    ]
  },
  {
    country: 'Sweden',
    countryCode: 'SE',
    states: [
      { name: 'Stockholm', cities: ['Stockholm', 'Solna', 'Sundbyberg'] },
      { name: 'Västra Götaland', cities: ['Gothenburg', 'Borås', 'Mölndal'] },
      { name: 'Skåne', cities: ['Malmö', 'Helsingborg', 'Lund'] }
    ]
  },
  {
    country: 'Portugal',
    countryCode: 'PT',
    states: [
      { name: 'Lisbon', cities: ['Lisbon', 'Sintra', 'Cascais', 'Amadora'] },
      { name: 'Porto', cities: ['Porto', 'Vila Nova de Gaia', 'Matosinhos'] },
      { name: 'Faro', cities: ['Faro', 'Albufeira', 'Portimão'] }
    ]
  },

  // ASIA
  {
    country: 'India',
    countryCode: 'IN',
    states: [
      { name: 'Maharashtra', cities: ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Aurangabad', 'Solapur'] },
      { name: 'Delhi', cities: ['New Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi'] },
      { name: 'Karnataka', cities: ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum'] },
      { name: 'Tamil Nadu', cities: ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem'] },
      { name: 'Gujarat', cities: ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar'] },
      { name: 'West Bengal', cities: ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri'] },
      { name: 'Telangana', cities: ['Hyderabad', 'Warangal', 'Nizamabad', 'Karimnagar'] },
      { name: 'Rajasthan', cities: ['Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur'] },
      { name: 'Uttar Pradesh', cities: ['Lucknow', 'Kanpur', 'Ghaziabad', 'Agra', 'Varanasi', 'Meerut', 'Allahabad'] },
      { name: 'Kerala', cities: ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Thrissur', 'Kollam'] },
      { name: 'Punjab', cities: ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala'] },
      { name: 'Haryana', cities: ['Faridabad', 'Gurgaon', 'Panipat', 'Ambala'] },
      { name: 'Madhya Pradesh', cities: ['Indore', 'Bhopal', 'Jabalpur', 'Gwalior'] },
      { name: 'Bihar', cities: ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur'] }
    ]
  },
  {
    country: 'China',
    countryCode: 'CN',
    states: [
      { name: 'Beijing', cities: ['Beijing', 'Chaoyang', 'Haidian', 'Dongcheng'] },
      { name: 'Shanghai', cities: ['Shanghai', 'Pudong', 'Huangpu', 'Xuhui'] },
      { name: 'Guangdong', cities: ['Guangzhou', 'Shenzhen', 'Dongguan', 'Foshan', 'Zhuhai'] },
      { name: 'Zhejiang', cities: ['Hangzhou', 'Ningbo', 'Wenzhou', 'Jiaxing'] },
      { name: 'Jiangsu', cities: ['Nanjing', 'Suzhou', 'Wuxi', 'Changzhou'] },
      { name: 'Sichuan', cities: ['Chengdu', 'Mianyang', 'Deyang'] },
      { name: 'Hubei', cities: ['Wuhan', 'Yichang', 'Xiangyang'] }
    ]
  },
  {
    country: 'Japan',
    countryCode: 'JP',
    states: [
      { name: 'Tokyo', cities: ['Tokyo', 'Shinjuku', 'Shibuya', 'Minato', 'Chiyoda'] },
      { name: 'Osaka', cities: ['Osaka', 'Sakai', 'Higashiosaka'] },
      { name: 'Kanagawa', cities: ['Yokohama', 'Kawasaki', 'Sagamihara'] },
      { name: 'Aichi', cities: ['Nagoya', 'Toyota', 'Okazaki'] },
      { name: 'Hokkaido', cities: ['Sapporo', 'Asahikawa', 'Hakodate'] },
      { name: 'Fukuoka', cities: ['Fukuoka', 'Kitakyushu', 'Kurume'] },
      { name: 'Kyoto', cities: ['Kyoto', 'Uji', 'Kameoka'] }
    ]
  },
  {
    country: 'Pakistan',
    countryCode: 'PK',
    states: [
      { name: 'Punjab', cities: ['Lahore', 'Faisalabad', 'Rawalpindi', 'Multan', 'Gujranwala', 'Sialkot'] },
      { name: 'Sindh', cities: ['Karachi', 'Hyderabad', 'Sukkur', 'Larkana'] },
      { name: 'Khyber Pakhtunkhwa', cities: ['Peshawar', 'Mardan', 'Abbottabad', 'Swat'] },
      { name: 'Balochistan', cities: ['Quetta', 'Gwadar', 'Turbat'] }
    ]
  },
  {
    country: 'Bangladesh',
    countryCode: 'BD',
    states: [
      { name: 'Dhaka', cities: ['Dhaka', 'Gazipur', 'Narayanganj', 'Tongi'] },
      { name: 'Chittagong', cities: ['Chittagong', 'Cox\'s Bazar', 'Comilla'] },
      { name: 'Khulna', cities: ['Khulna', 'Jessore', 'Satkhira'] },
      { name: 'Rajshahi', cities: ['Rajshahi', 'Bogra', 'Pabna'] }
    ]
  },
  {
    country: 'Indonesia',
    countryCode: 'ID',
    states: [
      { name: 'Java', cities: ['Jakarta', 'Surabaya', 'Bandung', 'Semarang', 'Yogyakarta', 'Malang'] },
      { name: 'Sumatra', cities: ['Medan', 'Palembang', 'Pekanbaru', 'Bandar Lampung'] },
      { name: 'Bali', cities: ['Denpasar', 'Ubud', 'Sanur', 'Kuta'] },
      { name: 'Sulawesi', cities: ['Makassar', 'Manado', 'Palu'] }
    ]
  },
  {
    country: 'Philippines',
    countryCode: 'PH',
    states: [
      { name: 'Metro Manila', cities: ['Manila', 'Quezon City', 'Makati', 'Pasig', 'Taguig', 'Mandaluyong'] },
      { name: 'Cebu', cities: ['Cebu City', 'Mandaue', 'Lapu-Lapu'] },
      { name: 'Davao', cities: ['Davao City', 'Tagum', 'Panabo'] },
      { name: 'Calabarzon', cities: ['Calamba', 'Antipolo', 'Dasmariñas'] }
    ]
  },
  {
    country: 'Vietnam',
    countryCode: 'VN',
    states: [
      { name: 'Hanoi', cities: ['Hanoi', 'Ba Đình', 'Hoàn Kiếm'] },
      { name: 'Ho Chi Minh', cities: ['Ho Chi Minh City', 'Thu Duc', 'Binh Thanh'] },
      { name: 'Da Nang', cities: ['Da Nang', 'Hai Chau', 'Son Tra'] },
      { name: 'Hai Phong', cities: ['Hai Phong', 'Hong Bang', 'Le Chan'] }
    ]
  },
  {
    country: 'Thailand',
    countryCode: 'TH',
    states: [
      { name: 'Bangkok', cities: ['Bangkok', 'Chatuchak', 'Bang Khen', 'Lat Krabang'] },
      { name: 'Chiang Mai', cities: ['Chiang Mai', 'San Sai', 'Hang Dong'] },
      { name: 'Phuket', cities: ['Phuket City', 'Patong', 'Kathu'] },
      { name: 'Nonthaburi', cities: ['Nonthaburi', 'Pak Kret', 'Bang Bua Thong'] }
    ]
  },
  {
    country: 'Malaysia',
    countryCode: 'MY',
    states: [
      { name: 'Kuala Lumpur', cities: ['Kuala Lumpur', 'Cheras', 'Kepong'] },
      { name: 'Selangor', cities: ['Shah Alam', 'Petaling Jaya', 'Subang Jaya', 'Klang'] },
      { name: 'Johor', cities: ['Johor Bahru', 'Pasir Gudang', 'Muar'] },
      { name: 'Penang', cities: ['George Town', 'Butterworth', 'Bayan Lepas'] }
    ]
  },
  {
    country: 'Singapore',
    countryCode: 'SG',
    states: [
      { name: 'Central', cities: ['Central Business District', 'Orchard', 'Marina Bay'] },
      { name: 'North', cities: ['Woodlands', 'Yishun', 'Sembawang'] },
      { name: 'East', cities: ['Tampines', 'Bedok', 'Pasir Ris'] },
      { name: 'West', cities: ['Jurong', 'Clementi', 'Bukit Batok'] }
    ]
  },
  {
    country: 'South Korea',
    countryCode: 'KR',
    states: [
      { name: 'Seoul', cities: ['Seoul', 'Gangnam', 'Jongno', 'Jung', 'Songpa'] },
      { name: 'Busan', cities: ['Busan', 'Haeundae', 'Suyeong'] },
      { name: 'Incheon', cities: ['Incheon', 'Bupyeong', 'Namdong'] },
      { name: 'Daegu', cities: ['Daegu', 'Suseong', 'Dalseo'] }
    ]
  },
  {
    country: 'Saudi Arabia',
    countryCode: 'SA',
    states: [
      { name: 'Riyadh', cities: ['Riyadh', 'Diriyah', 'Al Kharj'] },
      { name: 'Makkah', cities: ['Jeddah', 'Mecca', 'Taif'] },
      { name: 'Eastern Province', cities: ['Dammam', 'Khobar', 'Dhahran'] }
    ]
  },
  {
    country: 'United Arab Emirates',
    countryCode: 'AE',
    states: [
      { name: 'Dubai', cities: ['Dubai', 'Deira', 'Bur Dubai', 'Jumeirah'] },
      { name: 'Abu Dhabi', cities: ['Abu Dhabi', 'Al Ain', 'Ruwais'] },
      { name: 'Sharjah', cities: ['Sharjah', 'Kalba', 'Khor Fakkan'] }
    ]
  },
  {
    country: 'Israel',
    countryCode: 'IL',
    states: [
      { name: 'Tel Aviv', cities: ['Tel Aviv', 'Ramat Gan', 'Holon', 'Bat Yam'] },
      { name: 'Jerusalem', cities: ['Jerusalem', 'Beit Shemesh'] },
      { name: 'Haifa', cities: ['Haifa', 'Nesher', 'Tirat Carmel'] }
    ]
  },
  {
    country: 'Turkey',
    countryCode: 'TR',
    states: [
      { name: 'Istanbul', cities: ['Istanbul', 'Kadıköy', 'Şişli', 'Beşiktaş'] },
      { name: 'Ankara', cities: ['Ankara', 'Çankaya', 'Keçiören'] },
      { name: 'Izmir', cities: ['Izmir', 'Konak', 'Karşıyaka', 'Bornova'] }
    ]
  },

  // SOUTH AMERICA
  {
    country: 'Brazil',
    countryCode: 'BR',
    states: [
      { name: 'São Paulo', cities: ['São Paulo', 'Campinas', 'Santos', 'São Bernardo do Campo', 'Guarulhos'] },
      { name: 'Rio de Janeiro', cities: ['Rio de Janeiro', 'Niterói', 'Duque de Caxias', 'Nova Iguaçu'] },
      { name: 'Minas Gerais', cities: ['Belo Horizonte', 'Uberlândia', 'Contagem', 'Juiz de Fora'] },
      { name: 'Bahia', cities: ['Salvador', 'Feira de Santana', 'Vitória da Conquista'] },
      { name: 'Paraná', cities: ['Curitiba', 'Londrina', 'Maringá', 'Ponta Grossa'] },
      { name: 'Rio Grande do Sul', cities: ['Porto Alegre', 'Caxias do Sul', 'Pelotas', 'Canoas'] }
    ]
  },
  {
    country: 'Argentina',
    countryCode: 'AR',
    states: [
      { name: 'Buenos Aires', cities: ['Buenos Aires', 'La Plata', 'Mar del Plata', 'Bahía Blanca'] },
      { name: 'Córdoba', cities: ['Córdoba', 'Villa María', 'Río Cuarto'] },
      { name: 'Santa Fe', cities: ['Rosario', 'Santa Fe', 'Rafaela'] },
      { name: 'Mendoza', cities: ['Mendoza', 'San Rafael', 'Godoy Cruz'] }
    ]
  },
  {
    country: 'Colombia',
    countryCode: 'CO',
    states: [
      { name: 'Bogotá', cities: ['Bogotá', 'Soacha', 'Zipaquirá'] },
      { name: 'Antioquia', cities: ['Medellín', 'Bello', 'Itagüí', 'Envigado'] },
      { name: 'Valle del Cauca', cities: ['Cali', 'Palmira', 'Buenaventura'] },
      { name: 'Atlántico', cities: ['Barranquilla', 'Soledad', 'Malambo'] }
    ]
  },
  {
    country: 'Chile',
    countryCode: 'CL',
    states: [
      { name: 'Santiago Metropolitan', cities: ['Santiago', 'Puente Alto', 'Maipú', 'La Florida'] },
      { name: 'Valparaíso', cities: ['Valparaíso', 'Viña del Mar', 'Quilpué'] },
      { name: 'Biobío', cities: ['Concepción', 'Talcahuano', 'Los Ángeles'] }
    ]
  },
  {
    country: 'Peru',
    countryCode: 'PE',
    states: [
      { name: 'Lima', cities: ['Lima', 'Callao', 'San Juan de Lurigancho', 'San Martín de Porres'] },
      { name: 'Arequipa', cities: ['Arequipa', 'Cayma', 'Cerro Colorado'] },
      { name: 'La Libertad', cities: ['Trujillo', 'Chimbote'] }
    ]
  },
  {
    country: 'Venezuela',
    countryCode: 'VE',
    states: [
      { name: 'Capital District', cities: ['Caracas', 'Petare', 'Catia'] },
      { name: 'Zulia', cities: ['Maracaibo', 'Cabimas', 'Ciudad Ojeda'] },
      { name: 'Carabobo', cities: ['Valencia', 'Naguanagua', 'San Diego'] }
    ]
  },
  {
    country: 'Ecuador',
    countryCode: 'EC',
    states: [
      { name: 'Pichincha', cities: ['Quito', 'Cayambe', 'Machachi'] },
      { name: 'Guayas', cities: ['Guayaquil', 'Durán', 'Milagro'] },
      { name: 'Azuay', cities: ['Cuenca', 'Gualaceo', 'Paute'] }
    ]
  },

  // OCEANIA
  {
    country: 'Australia',
    countryCode: 'AU',
    states: [
      { name: 'New South Wales', cities: ['Sydney', 'Newcastle', 'Wollongong', 'Central Coast', 'Parramatta', 'Liverpool'] },
      { name: 'Victoria', cities: ['Melbourne', 'Geelong', 'Ballarat', 'Bendigo', 'Shepparton'] },
      { name: 'Queensland', cities: ['Brisbane', 'Gold Coast', 'Townsville', 'Cairns', 'Toowoomba'] },
      { name: 'Western Australia', cities: ['Perth', 'Fremantle', 'Mandurah', 'Bunbury'] },
      { name: 'South Australia', cities: ['Adelaide', 'Mount Gambier', 'Whyalla'] },
      { name: 'Tasmania', cities: ['Hobart', 'Launceston', 'Devonport'] },
      { name: 'Australian Capital Territory', cities: ['Canberra', 'Queanbeyan'] },
      { name: 'Northern Territory', cities: ['Darwin', 'Alice Springs', 'Palmerston'] }
    ]
  },
  {
    country: 'New Zealand',
    countryCode: 'NZ',
    states: [
      { name: 'Auckland', cities: ['Auckland', 'Manukau', 'North Shore', 'Waitakere'] },
      { name: 'Wellington', cities: ['Wellington', 'Lower Hutt', 'Upper Hutt', 'Porirua'] },
      { name: 'Canterbury', cities: ['Christchurch', 'Timaru', 'Ashburton'] },
      { name: 'Waikato', cities: ['Hamilton', 'Tauranga', 'Rotorua'] },
      { name: 'Otago', cities: ['Dunedin', 'Queenstown', 'Wanaka'] }
    ]
  }
];

// General user interests that cut across all areas of life
export const GENERAL_INTERESTS = [
  'Technology',
  'Business',
  'Entrepreneurship',
  'Finance',
  'Real Estate',
  'Health & Fitness',
  'Sports',
  'Travel',
  'Food & Cooking',
  'Fashion',
  'Beauty',
  'Music',
  'Movies & TV',
  'Books & Reading',
  'Art & Design',
  'Photography',
  'Gaming',
  'Education',
  'Parenting',
  'Relationships',
  'Self Development',
  'Career',
  'Science',
  'Nature & Environment',
  'Pets & Animals',
  'Home & Garden',
  'DIY & Crafts',
  'Automotive',
  'Faith & Spirituality',
  'Community Service',
  'Politics & News',
  'Shopping',
  'Entertainment'
];

// Helper function to get country by code
export const getCountryByCode = (code: string): Location | undefined => {
  return LOCATIONS.find(loc => loc.countryCode === code);
};

// Helper function to get all states for a country
export const getStatesForCountry = (countryCode: string): State[] => {
  const country = getCountryByCode(countryCode);
  return country?.states || [];
};

// Helper function to get cities for a state
export const getCitiesForState = (countryCode: string, stateName: string): string[] => {
  const states = getStatesForCountry(countryCode);
  const state = states.find(s => s.name === stateName);
  return state?.cities || [];
};

// Check if user location matches ad targeting
export const matchesLocation = (
  userLocation: UserLocation,
  targetLocations: {
    countries: string[];
    states: { [country: string]: string[] };
    cities: { [country: string]: { [state: string]: string[] } };
  }
): boolean => {
  // If no targeting specified, show to everyone
  if (targetLocations.countries.length === 0) {
    return true;
  }

  // Check if user's country is targeted
  if (!targetLocations.countries.includes(userLocation.countryCode)) {
    return false;
  }

  // If only country is targeted (no states specified), match
  const countryStates = targetLocations.states[userLocation.countryCode];
  if (!countryStates || countryStates.length === 0) {
    return true;
  }

  // Check if user's state is targeted
  if (!userLocation.state || !countryStates.includes(userLocation.state)) {
    return false;
  }

  // If only state is targeted (no cities specified), match
  const stateCities = targetLocations.cities[userLocation.countryCode]?.[userLocation.state];
  if (!stateCities || stateCities.length === 0) {
    return true;
  }

  // Check if user's city is targeted
  return userLocation.city ? stateCities.includes(userLocation.city) : false;
};
